/**
 * @generated SignedSource<<a379e175263fd2f11f89b36c30827f10>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type paymentBaseInlineFragment$data = {
  readonly id: string;
  readonly paidAt: any | null;
  readonly amount: number;
  readonly currencyCode: string;
  readonly accountId: string;
  readonly createdAt: any | null;
  readonly updatedAt: any | null;
  readonly deletedAt: any | null;
  readonly " $fragmentType": "paymentBaseInlineFragment";
};
export type paymentBaseInlineFragment$key = {
  readonly " $data"?: paymentBaseInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"paymentBaseInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "paymentBaseInlineFragment"
};

(node as any).hash = "0a2b8f9161f20fb8fc2b8819c0b12c9c";

export default node;
